module.exports = __webpack_public_path__ + "static/media/guide_1.b926abff.png";